export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5303.a855cf04.jpg";